var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20.5,
    viewBox: "0 0 21 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #00b0a9;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #00b0a9;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10499",
    "data-name": "Group 10499",
    transform: "translate(-512.5 -776.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10488",
    "data-name": "Group 10488",
    transform: "translate(19085 3250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    className: "cls-1",
    d: "M18.364,33.984H10.7V23.732a.487.487,0,0,1,.284-.464l1.781-.826v-2.3a.477.477,0,0,1,.284-.439l8.232-4.155c.026-.026.026-.026.052-.026a.09.09,0,0,1,.052-.026h.206a.09.09,0,0,0,.052.026c.026.026.026.026.052.026l3.561,1.806a.477.477,0,0,1,.284.439v2.245l2.132-.53c.026,0,3.029,1.924,3.029,1.924V33.984H24.654",
    transform: "translate(-18582.699 -2488.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7372",
    "data-name": "Path 7372",
    className: "cls-2",
    d: "M-22923.705-20453.516v-14.312",
    transform: "translate(4368.684 17999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7373",
    "data-name": "Path 7373",
    className: "cls-2",
    d: "M-22923.705-20447.664v-13.07",
    transform: "translate(4357.277 17993.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7374",
    "data-name": "Path 7374",
    className: "cls-2",
    d: "M-22923.705-20445.025v-15.717",
    transform: "translate(4362.438 17987.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7375",
    "data-name": "Path 7375",
    className: "cls-2",
    d: "M-22927.756-20466.562v13.941",
    transform: "translate(4370.605 17998.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7376",
    "data-name": "Path 7376",
    className: "cls-1",
    d: "M-22977.391-20461.529l3.479-1.51,2.893.176v10.186",
    transform: "translate(4407.431 17995.451)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1828",
    "data-name": "Ellipse 1828",
    className: "cls-3",
    cx: 1.571,
    cy: 1.571,
    r: 1.571,
    transform: "translate(-18562.857 -2456.143)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3092",
    "data-name": "Rectangle 3092",
    className: "cls-4",
    width: 20,
    height: 20,
    transform: "translate(513 777)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProjects);
export default __webpack_public_path__ + "static/media/totalProjects.1f2259922059404218ae09679f84c819.svg";
export { ForwardRef as ReactComponent };